import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkFilledIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 0.833008C4.93743 0.833008 0.833374 4.93706 0.833374 9.99967C0.833374 15.0623 4.93743 19.1663 10 19.1663C15.0626 19.1663 19.1667 15.0623 19.1667 9.99967C19.1667 4.93706 15.0626 0.833008 10 0.833008ZM14.3393 8.08893C14.6647 7.76349 14.6647 7.23586 14.3393 6.91042C14.0139 6.58498 13.4862 6.58498 13.1608 6.91042L8.75004 11.3212L6.8393 9.41042C6.51386 9.08498 5.98622 9.08498 5.66078 9.41042C5.33535 9.73586 5.33535 10.2635 5.66078 10.5889L8.16078 13.0889C8.48622 13.4144 9.01386 13.4144 9.3393 13.0889L14.3393 8.08893Z",
		fill: "currentColor"
	})
});
export default SvgCheckmarkFilledIcon;
